module.exports = __webpack_public_path__ + "img/Unidad12-6.402d1211.png";